var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 pt-4"},[(
      _vm.isSitecoreExperienceEditorOn ||
        (_vm.fields.SectionTitle && _vm.fields.SectionTitle.value && _vm.fields.SectionTitle.value !== '')
    )?_c('div',{staticClass:"global-typography"},[_c('sc-text',{staticClass:"section-title",class:{
        'pb-6': _vm.$vuetify.breakpoint.smAndUp,
        'pb-3': _vm.$vuetify.breakpoint.xsOnly,
      },attrs:{"field":this.fields.SectionTitle,"tag":"h2"}})],1):_vm._e(),_c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('sc-placeholder',{staticClass:"image-cards-row row",attrs:{"name":"jssimagecards","rendering":_vm.rendering}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }